import { render, staticRenderFns } from "./DashboardOrderStatistics.vue?vue&type=template&id=8b7ede22&scoped=true&"
import script from "./DashboardOrderStatistics.vue?vue&type=script&lang=js&"
export * from "./DashboardOrderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOrderStatistics.vue?vue&type=style&index=0&id=8b7ede22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7ede22",
  null
  
)

export default component.exports